// @ts-nocheck
/**
 * YMQ Custom — Namespace & Config
 *
 * ⚠️ File này PHẢI được load TRƯỚC TIÊN, trước tất cả các file ymq-*.js khác.
 *
 * Khởi tạo namespace toàn cục `window.YMQCustom` để các module khác
 * gắn các hàm public vào. Chỉ chứa config (read-only), state riêng của
 * từng module sẽ được giữ private trong IIFE của module đó.
 *
 * Written by: Sy Thai
 * Date: May 06, 2026
 */

window.YMQCustom = window.YMQCustom || {};

// Config dùng chung (có thể override trước khi các module khác load)
window.YMQCustom.config = Object.assign(
  {
    SHIPPING_API_URL: "/apps/onestore-proxy?action=/price/calculate",
    SHIPPING_LOG: "[shipping_fee_auto_select]",
  },
  window.YMQCustom.config || {},
);

/**
 * Batch callbacks that react to YMQ DOM churn.
 * YMQ can mutate hundreds of nodes per option change; running theme
 * callbacks on every mutation freezes the modal. One rAF per key is enough.
 */
window.YMQCustom.schedule = (function () {
  const pending = new Map();
  return function schedule(key, fn) {
    if (pending.has(key)) return;
    pending.set(
      key,
      requestAnimationFrame(() => {
        pending.delete(key);
        fn();
      }),
    );
  };
})();

/**
 * Observe a target, but disconnect for the rest of the burst so we only
 * run `callback` once after YMQ finishes mutating.
 */
window.YMQCustom.observeIdle = function observeIdle(
  target,
  options,
  callback,
  key,
) {
  if (!target) return null;
  const id = key || `obs-${Math.random().toString(36).slice(2, 8)}`;
  let paused = false;
  const observer = new MutationObserver(() => {
    if (paused) return;
    paused = true;
    observer.disconnect();
    window.YMQCustom.schedule(id, () => {
      try {
        callback();
      } finally {
        requestAnimationFrame(() => {
          paused = false;
          observer.observe(target, options);
        });
      }
    });
  });
  observer.observe(target, options);
  return observer;
};
